import type { ReactNode } from 'react';
import React from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import styles from '../textArea.module.scss';

/** Custom props */
export type TextfieldHelperTextProps = {
  /** The content of the component */
  children?: ReactNode;

  /** Custom class to overwrite default styling if needed */
  className?: string;

  /** Flag to indicate there is an errortext being shown */
  hasErrorText?: boolean;
};

export function HelperText(props: TextfieldHelperTextProps) {
  const { children, className, hasErrorText } = props;
  const classNames = cx(
    styles[toCamelCase('textArea', 'helperText')],
    !hasErrorText && styles[toCamelCase('textArea', 'helperText', 'noError')],
    className,
  );

  return (
    <div className={classNames} data-testid="textArea-helperText">
      {children}
    </div>
  );
}

export default HelperText;
